import HustleLogo from "../components/HustleLogo";
import ChartSwitcher from "../components/ChartSwitcher";
import AddVentureButton from "../components/AddVentureButton";
import TimeRangeSelector from "../components/TimeRangeSelector";
import PortfolioTotals from "../components/PortfolioTotals";
import BusinessList from "../components/BusinessList";
import SidebarDrawer from "../components/ui/sidebar";
import PieChart from "../components/PieChart";
import BarChart from "../components/BarChart";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const DEMO_DATA = {
  ytd: {
    profit: 27430,
    expenses: 15300,
    ventures: [
      { name: "HSM Printing", profit: 12000, expenses: 7000, color: "hsl(var(--chart-2))" },
      { name: "BBA", profit: 14500, expenses: 4800, color: "hsl(var(--chart-3))" },
      { name: "Petal & Forever", profit: 930, expenses: 3500, color: "hsl(var(--chart-4))" },
    ],
  },
  mtd: {
    profit: 8700,
    expenses: 5400,
    ventures: [
      { name: "HSM Printing", profit: 4000, expenses: 2500, color: "hsl(var(--chart-2))" },
      { name: "BBA", profit: 4500, expenses: 1800, color: "hsl(var(--chart-3))" },
      { name: "Petal & Forever", profit: 200, expenses: 1100, color: "hsl(var(--chart-4))" },
    ],
  },
  wtd: {
    profit: 2100,
    expenses: 1200,
    ventures: [
      { name: "HSM Printing", profit: 850, expenses: 400, color: "hsl(var(--chart-2))" },
      { name: "BBA", profit: 1100, expenses: 650, color: "hsl(var(--chart-3))" },
      { name: "Petal & Forever", profit: 150, expenses: 150, color: "hsl(var(--chart-4))" },
    ],
  },
};

const Index = () => {
  const [showModal, setShowModal] = useState(false);
  const [range, setRange] = useState<"ytd" | "mtd" | "wtd">("ytd");
  const chartData = DEMO_DATA[range];
  const navigate = useNavigate();

  // const pieData = [
  //   { label: "Profit", value: chartData.profit, color: "#14b8a6" },
  //   { label: "Expenses", value: chartData.expenses, color: "#fde047" },
  // ];
  const pieData = chartData.ventures.map(v => ({ label: v.name, value: v.profit, color: v.color }));

  const barData = chartData.ventures.map(v => ({ label: v.name, value: v.profit, color: v.color }));
  return (
    <SidebarDrawer>
      <div className="relative min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-slate-50 to-white dark:from-background dark:to-card">
        <AddVentureButton onClick={() => setShowModal(true)} />
        <div className="pt-6 pb-10 w-full flex flex-col items-center">
          <div className="mt-5 mb-0 flex justify-center">
            <HustleLogo style={{ width: "200%", maxWidth: 220, height: "auto" }} />
          </div>
          <div className="w-full flex flex-col items-center mt-6 mb-2 gap-2">
            <div className="mb-6 w-full flex flex-col items-center">
              <ChartSwitcher
                leftTitle="Pie"
                rightTitle="Bar"
                left={<PieChart data={pieData} size={136} />}
                right={
                  <div className="w-full max-w-xs mx-auto">
                    <div className="font-semibold text-primary/80 text-sm mb-1 ml-1">Profit by Venture</div>
                    <div className="flex gap-2 items-end h-24">
                      {barData.map(bar => (
                        <div key={bar.label} className="flex-1 flex flex-col items-center">
                          <div
                            className="rounded-lg"
                            style={{
                              background: bar.color,
                              height: `${Math.max(16, (bar.value / chartData.profit) * 82)}px`,
                              width: "24px",
                            }}
                          />
                          <div className="text-[10px] text-center mt-1 font-bold whitespace-nowrap text-muted-foreground">{bar.label}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                }
              />
            </div>
            <div className="mb-3">
              <div className="inline-flex gap-2">
                <button
                  className={`px-2 py-0.5 rounded font-semibold text-xs transition ${range === 'ytd' ? 'bg-primary/90 text-white' : 'bg-muted text-primary/80 hover:bg-primary/20'}`}
                  onClick={() => setRange('ytd')}>YTD</button>
                <button
                  className={`px-2 py-0.5 rounded font-semibold text-xs transition ${range === 'mtd' ? 'bg-primary/90 text-white' : 'bg-muted text-primary/80 hover:bg-primary/20'}`}
                  onClick={() => setRange('mtd')}>MTD</button>
                <button
                  className={`px-2 py-0.5 rounded font-semibold text-xs transition ${range === 'wtd' ? 'bg-primary/90 text-white' : 'bg-muted text-primary/80 hover:bg-primary/20'}`}
                  onClick={() => setRange('wtd')}>WTD</button>
              </div>
            </div>
          </div>
          <PortfolioTotals profit={chartData.profit} expenses={chartData.expenses} />
          <div className="mb-4">
            <ChartSwitcher ventures={chartData.ventures} />
          </div>
          <BusinessList ventures={chartData.ventures} onSelectVenture={(v) => navigate(`/venture/${encodeURIComponent(v.name)}`)} />
          <p className="text-base md:text-lg text-muted-foreground max-w-md text-center mt-4 font-medium">
            Your financial dashboard for
            <span className="whitespace-nowrap font-bold text-primary ml-1">profit, expenses & growth</span>.<br />
            Effortless performance tracking across all your ventures.
          </p>
        </div>
        {/* Placeholder for Add Venture Modal if showModal */}
      </div>
    </SidebarDrawer>
  );
};

export default Index;